import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink-950 py-10" data-id="element-31" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-32" data-mp="3ggaq1tbg494e">
        <p className="font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-33" data-mp="32o4deh7i4k9p">
          Método Mecánica Inteligente
        </p>
        <p className="mt-3 text-xs leading-relaxed text-white/40" data-id="element-34" data-mp="36q953aee36tp">
          Producto 100% digital. Los ahorros mencionados son estimaciones
          basadas en costos habituales de mantenimiento y no constituyen una
          garantía de resultados.
        </p>
        <p className="mt-4 text-xs text-white/30" data-id="element-35" data-mp="3levgx24t5gg6">
          © {new Date().getFullYear()} Mecánica Inteligente. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}